import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
    getAllLeadLogs,
} from "../../../actions/emActions";
import RightSectionEM from "../RightSectionEM/RightSectionEM";
import HeaderComponent from "../../website/HeaderComponent";
import moment from "moment";

const LeadLogs = (props) => {
    const [incomplete, setincomplete] = useState('');
    const [loadCount, setloadCount] = useState(2);
    const [loadmoreloader, setloadmoreloader] = useState(false);
    useEffect(() => {
        props.getAllLeadLogs(1)
            .then((res) => {
                debugger;
                setincomplete(res.data.result);
                console.log(res);
            })
            .catch((err) => {
                console.log(err);
                debugger;
            })
    }, [])

    const loadMoreFunction = () => {
        const { loggedUserId } = props;
        setloadmoreloader(true);
        props.getAllLeadLogs(loadCount)
            .then((res) => {
                setincomplete([...incomplete, ...res.data.result]);
                setloadmoreloader(false);
                setloadCount(loadCount + 1);
            })
            .catch((err) => {
                console.log(err);
                debugger;
            })
    };

    const ActionConditions = (data , action , label) => {
        if(action == "demo_attended" && label == 1) {
            return <span className="font-weight-bold text-success"> <i style={{fontSize: 14}} className="fas fa-dollar-sign"></i> Demo Attended</span>
        }
        if(action == "demo_attended" && label == 0) {
            return <span className="font-weight-bold text-danger"><i className="fas fa-frown" style={{fontSize: 13}}></i> Demo Not Attended</span>
        }
        else if(action == "demo_scheduled" && label == 1) {
            return <span className="font-weight-bold text-primary">Demo Scheduled</span>
        }
        else if(action == "curriculum_img" && label == 1) {
            return <span className="font-weight-bold text-muted">{data.video_name} Image Sent</span>
        }
        else if(action == "testimonial_video" && label == 1) {
            return <span className="font-weight-bold text-muted">Video Sent</span>
        }
        else if(action == "initial_message" && label == 1) {
            return <span className="font-weight-bold text-muted">Initial Message Sent</span>
        }
        else if(action == "own" && label == 1) {
            return <span className="font-weight-bold text-muted">Lead Owned</span>
        }
        else if(action == "demo_missed_video" && label == 0) {
            return <span className="font-weight-bold text-muted">Missed Video Sent</span>
        }
        else if(action == "demo_reminder" && label == 1) {
            return <span className="font-weight-bold text-muted">Reminder Message Sent</span>
        }
        else if(action == "initial_call" && label == 0) {
            return <span className="font-weight-bold text-muted">Parent Did not Pickup</span>
        }
        else if(action == "initial_call" && label == 1) {
            return <span className="font-weight-bold text-muted">Parent Picked up</span>
        }
        else if(action == "initial_call_not_attended_message" && label == 0) {
            return <span className="font-weight-bold text-muted">Call Not Attended Message Sent</span>
        }
        else if(action == "send_group_price" && label == 1) {
            return <span className="font-weight-bold text-muted">Group Price Sent</span>
        }
        else if(action == "send_oneonone_price" && label == 1) {
            return <span className="font-weight-bold text-muted">One on One Price Sent</span>
        }
        else if(action == "demo_video_reminder" && label == 1) {
            return <span className="font-weight-bold text-muted">Video Reminder Sent</span>
        }
        else if(action == "not_interested" && label == 1) {
            return <span className="font-weight-bold text-muted">Lead Not Interested</span>
        }
        else if(action == "activity_notes" && label == 1) {
            return <span className="font-weight-bold text-muted">Activity Notes Added</span>
        }
        else if(action == "user_confirm" && label == 1) {
            return <span className="font-weight-bold text-success">Parent wants to continue</span>
        }
        else {
            return <span>{action}</span>
        }
    }
    console.log("Leads Logs", incomplete);
    return (
        <div className="FeedComponent FeedComponentForTeacher">
            <HeaderComponent
            // whiteLabel={this.state.isWhiteLabel}
            // headerData={{ studentName: this.state.teacherInfo.user_name }}
            />
            <div style={{ padding: "2vh 0" }}>
                <div className="container-fluid">
                    <div className="row">

                        <div className="col-md-3">
                            <RightSectionEM />
                        </div>

                        <div className="col-md-9">

                            <h5 className="mt-4">Leads Logs</h5>

                            {/* <hr /> */}
                            <div className="table-responsive tableMobileView">
                                <table class="table table-striped table-sm mt-4">
                                    <thead className="tableHeader">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Action by</th>
                                            <th scope="col">Lead Name</th>
                                            <th scope="col">Course Name</th>
                                            <th scope="col">Action Taken</th>
                                            <th scope="col">Date</th>
                                            <th scope="col">Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {incomplete && incomplete.map((item, index) =>
                                            <tr>
                                                <th scope="row">{index + 1}</th>
                                                <td>{item.em_name && item.em_name ? <span className="font-weight-bold text-success"> {item.em_name}</span> : <span className="text-muted">System</span>}</td>
                                                <td>{item.first_name} {item.last_name}</td>
                                                <td>{item.course_name}</td>
                                                <td>
                                                    
                                                    {ActionConditions(item , item.demo_status_history_label , item.demo_status_history)}
                                                    
                                                </td>
                                                <td>{moment(item.ts).format('ll')}</td>
                                                <td>{moment(item.ts).format('LT')}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="text-center">
                                <div id="loadMore">
                                    <a onClick={loadMoreFunction}>
                                        Load More <i className="fas fa-arrow-down"></i>
                                    </a>
                                    {loadmoreloader ? (
                                        <div className="mt-2">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                            ""
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, {
    getAllLeadLogs,
})(LeadLogs);